"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeConfig = normalizeConfig;

var _log = _interopRequireWildcard(require("./log"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function normalizeConfig(config) {
  // Quick structure validation

  /**
  * type FilePath = string
  * type RawFile = { raw: string, extension?: string }
  * type ExtractorFn = (content: string) => Array<string>
  * type TransformerFn = (content: string) => string
  *
  * type Content =
  *   | Array<FilePath | RawFile>
  *   | {
  *       files: Array<FilePath | RawFile>,
  *       extract?: ExtractorFn | { [extension: string]: ExtractorFn }
  *       transform?: TransformerFn | { [extension: string]: TransformerFn }
  *   }
  */
  var valid = function () {
    // `config.purge` should not exist anymore
    if (config.purge) {
      return false;
    } // `config.content` should exist


    if (!config.content) {
      return false;
    } // `config.content` should be an object or an array


    if (!Array.isArray(config.content) && !(typeof config.content === 'object' && config.content !== null)) {
      return false;
    } // When `config.content` is an array, it should consist of FilePaths or RawFiles


    if (Array.isArray(config.content)) {
      return config.content.every(function (path) {
        // `path` can be a string
        if (typeof path === 'string') return true; // `path` can be an object { raw: string, extension?: string }
        // `raw` must be a string

        if (typeof (path === null || path === void 0 ? void 0 : path.raw) !== 'string') return false; // `extension` (if provided) should also be a string

        if ((path === null || path === void 0 ? void 0 : path.extension) && typeof (path === null || path === void 0 ? void 0 : path.extension) !== 'string') {
          return false;
        }

        return true;
      });
    } // When `config.content` is an object


    if (typeof config.content === 'object' && config.content !== null) {
      // Only `files`, `extract` and `transform` can exist in `config.content`
      if (Object.keys(config.content).some(function (key) {
        return !['files', 'extract', 'transform'].includes(key);
      })) {
        return false;
      } // `config.content.files` should exist of FilePaths or RawFiles


      if (Array.isArray(config.content.files)) {
        if (!config.content.files.every(function (path) {
          // `path` can be a string
          if (typeof path === 'string') return true; // `path` can be an object { raw: string, extension?: string }
          // `raw` must be a string

          if (typeof (path === null || path === void 0 ? void 0 : path.raw) !== 'string') return false; // `extension` (if provided) should also be a string

          if ((path === null || path === void 0 ? void 0 : path.extension) && typeof (path === null || path === void 0 ? void 0 : path.extension) !== 'string') {
            return false;
          }

          return true;
        })) {
          return false;
        } // `config.content.extract` is optional, and can be a Function or a Record<String, Function>


        if (typeof config.content.extract === 'object') {
          for (var _i = 0, _Object$values = Object.values(config.content.extract); _i < _Object$values.length; _i++) {
            var value = _Object$values[_i];

            if (typeof value !== 'function') {
              return false;
            }
          }
        } else if (!(config.content.extract === undefined || typeof config.content.extract === 'function')) {
          return false;
        } // `config.content.transform` is optional, and can be a Function or a Record<String, Function>


        if (typeof config.content.transform === 'object') {
          for (var _i2 = 0, _Object$values2 = Object.values(config.content.transform); _i2 < _Object$values2.length; _i2++) {
            var _value = _Object$values2[_i2];

            if (typeof _value !== 'function') {
              return false;
            }
          }
        } else if (!(config.content.transform === undefined || typeof config.content.transform === 'function')) {
          return false;
        }
      }

      return true;
    }

    return false;
  }();

  if (!valid) {
    _log.default.warn('purge-deprecation', ['The `purge`/`content` options have changed in Tailwind CSS v3.0.', 'Update your configuration file to eliminate this warning.']);
  } // Normalize the `safelist`


  config.safelist = function () {
    var ref;
    var content = config.content,
        purge = config.purge,
        safelist = config.safelist;
    if (Array.isArray(safelist)) return safelist;
    if (Array.isArray(content === null || content === void 0 ? void 0 : content.safelist)) return content.safelist;
    if (Array.isArray(purge === null || purge === void 0 ? void 0 : purge.safelist)) return purge.safelist;
    if (Array.isArray(purge === null || purge === void 0 ? void 0 : (ref = purge.options) === null || ref === void 0 ? void 0 : ref.safelist)) return purge.options.safelist;
    return [];
  }(); // Normalize prefix option


  if (typeof config.prefix === 'function') {
    _log.default.warn('prefix-function', ['As of Tailwind CSS v3.0, `prefix` cannot be a function.', 'Update `prefix` in your configuration to be a string to eliminate this warning.']);

    config.prefix = '';
  } else {
    var _prefix;

    config.prefix = (_prefix = config.prefix) !== null && _prefix !== void 0 ? _prefix : '';
  } // Normalize the `content`


  config.content = {
    files: function () {
      var content = config.content,
          purge = config.purge;
      if (Array.isArray(purge)) return purge;
      if (Array.isArray(purge === null || purge === void 0 ? void 0 : purge.content)) return purge.content;
      if (Array.isArray(content)) return content;
      if (Array.isArray(content === null || content === void 0 ? void 0 : content.content)) return content.content;
      if (Array.isArray(content === null || content === void 0 ? void 0 : content.files)) return content.files;
      return [];
    }(),
    extract: function () {
      var extract = function () {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        if ((ref = config.purge) === null || ref === void 0 ? void 0 : ref.extract) return config.purge.extract;
        if ((ref1 = config.content) === null || ref1 === void 0 ? void 0 : ref1.extract) return config.content.extract;
        if ((ref2 = config.purge) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.extract) === null || ref3 === void 0 ? void 0 : ref3.DEFAULT) return config.purge.extract.DEFAULT;
        if ((ref4 = config.content) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.extract) === null || ref5 === void 0 ? void 0 : ref5.DEFAULT) return config.content.extract.DEFAULT;
        if ((ref6 = config.purge) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.options) === null || ref7 === void 0 ? void 0 : ref7.extractors) return config.purge.options.extractors;
        if ((ref8 = config.content) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.options) === null || ref9 === void 0 ? void 0 : ref9.extractors) return config.content.options.extractors;
        return {};
      }();

      var extractors = {};

      var defaultExtractor = function () {
        var ref, ref10, ref11, ref12;

        if ((ref = config.purge) === null || ref === void 0 ? void 0 : (ref10 = ref.options) === null || ref10 === void 0 ? void 0 : ref10.defaultExtractor) {
          return config.purge.options.defaultExtractor;
        }

        if ((ref11 = config.content) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.options) === null || ref12 === void 0 ? void 0 : ref12.defaultExtractor) {
          return config.content.options.defaultExtractor;
        }

        return undefined;
      }();

      if (defaultExtractor !== undefined) {
        extractors.DEFAULT = defaultExtractor;
      } // Functions


      if (typeof extract === 'function') {
        extractors.DEFAULT = extract;
      } else if (Array.isArray(extract)) {
        var _iterator = _createForOfIteratorHelper(extract !== null && extract !== void 0 ? extract : []),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _step.value,
                extensions = _step$value.extensions,
                extractor = _step$value.extractor;

            var _iterator2 = _createForOfIteratorHelper(extensions),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var extension = _step2.value;
                extractors[extension] = extractor;
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (typeof extract === 'object' && extract !== null) {
        Object.assign(extractors, extract);
      }

      return extractors;
    }(),
    transform: function () {
      var transform = function () {
        var ref, ref13, ref14, ref15, ref16, ref17;
        if ((ref = config.purge) === null || ref === void 0 ? void 0 : ref.transform) return config.purge.transform;
        if ((ref13 = config.content) === null || ref13 === void 0 ? void 0 : ref13.transform) return config.content.transform;
        if ((ref14 = config.purge) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.transform) === null || ref15 === void 0 ? void 0 : ref15.DEFAULT) return config.purge.transform.DEFAULT;
        if ((ref16 = config.content) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.transform) === null || ref17 === void 0 ? void 0 : ref17.DEFAULT) return config.content.transform.DEFAULT;
        return {};
      }();

      var transformers = {};

      if (typeof transform === 'function') {
        transformers.DEFAULT = transform;
      }

      if (typeof transform === 'object' && transform !== null) {
        Object.assign(transformers, transform);
      }

      return transformers;
    }()
  }; // Validate globs to prevent bogus globs.
  // E.g.: `./src/*.{html}` is invalid, the `{html}` should just be `html`

  var _iterator3 = _createForOfIteratorHelper(config.content.files),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var file = _step3.value;

      if (typeof file === 'string' && /{([^,]*?)}/g.test(file)) {
        _log.default.warn('invalid-glob-braces', ["The glob pattern ".concat((0, _log).dim(file), " in your config is invalid."), "    Update it to ".concat((0, _log).dim(file.replace(/{([^,]*?)}/g, '$1')), " to silence this warning.")]);

        break;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  if (config.content.files.length === 0) {
    _log.default.warn('content-problems', ['The `content` key is missing or empty. Please populate the content key as Tailwind generates utilities on-demand based on the files that use them. For more information see the documentation: https://tailwindcss.com/docs/content-configuration']);
  }

  return config;
}